/**
 * This function converts a string to a rich text paragraph.
 * @param string - The string to convert.
 * @returns The rich text paragraph.
 */
export const stringToRichText = (string: string | undefined | null) => {
  if (!string) return '';

  return `<p>${string}</p>`;
};

/**
 * This function converts a comma separated string to a rich text list.
 * @param string - The comma separated string to convert.
 * @returns The rich text list.
 */
export const stringToRichTextList = (string: string | undefined | null) => {
  if (!string) return undefined;
  const stringArray = string.split(',');

  const listItems = stringArray.map((item) => `<li>${item}</li>`).join('');
  return `<ul>${listItems}</ul>`;
};
